import { getSubOption, mapSubcategoryToTours } from 'data/filters';
import { useState } from 'react';

const getSubcategoriesFilters = (buckets, subcategoryMap) =>
  Object.keys(subcategoryMap)
    .map((key) => getSubOption('subcategory.items[]', key))
    .filter((subCategory) =>
      buckets.some(
        ({ key }) =>
          key === subCategory?.queryValue || key === subCategory.value,
      ),
    );

function useToursFilter(initialSelectedFilters, aggregations) {
  const hasToursFilter = initialSelectedFilters
    .find((filter) => filter.uid === 'activityType.activity')
    ?.subOptions.some((subCategory) => subCategory.value === 'tours');

  const subCategoryFilter = initialSelectedFilters.find(
    (filter) => filter.uid === 'subcategory.items[]',
  );

  const activitiesFilter =
    subCategoryFilter?.subOptions
      ?.filter(({ value }) => value && mapSubcategoryToTours[value])
      ?.map(({ value }) => value) || [];

  const toursSubcategoriesFilters = getSubcategoriesFilters(
    aggregations?.global?.location_filtered?.subcategories?.buckets || [],
    mapSubcategoryToTours,
  );

  const nrOfFiltersPossible = toursSubcategoriesFilters.length;

  const [toursOptions, setToursOptions] = useState<string[]>(activitiesFilter);
  const [toursFilterStatus, setToursFilterStatus] = useState(hasToursFilter);

  const onToggleAllTours = () => {
    setToursOptions([]);
    setToursFilterStatus(!toursFilterStatus);
  };

  const onToggleTours = (value: string) => {
    if (toursOptions.includes(value)) {
      setToursOptions(
        (prevDuration) => prevDuration.filter((item) => item !== value) || [],
      );
      setToursFilterStatus(false);
    } else {
      if (toursOptions.length + 1 === nrOfFiltersPossible) {
        setToursOptions([]);
        setToursFilterStatus(true);
      } else {
        setToursOptions((prevDuration) => [...prevDuration, value]);
        setToursFilterStatus(false);
      }
    }
  };

  return {
    toursOptions,
    toursFilterStatus,
    onToggleTours,
    onToggleAllTours,
  };
}

export default useToursFilter;
